import React, { useState } from 'react'
import { APILINK } from '../../EndPoint';
import axiosInstance from '../../api/axiosInstance';
import ErrorHandler from "../../error-handler/ErrorHandler"
import { useSelector } from 'react-redux'
import { Select, DatePicker,Button } from "antd"
import { Container, Row, Col, } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import Download from "./download"

const Signature = (props) => {
    const { t } = useTranslation();

  return (
      <Download title={t("reports.signature")} url="completed_signatures_report" />
  )
}

export default ErrorHandler(Signature, axiosInstance)